import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api' });

// Attach token to every request (if present)
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Response interceptor: normalize errors and handle 401/403 globally
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.message || error.message || 'Request failed';
    error.userMessage = message;

    // If unauthorized (401) clear client auth and broadcast an event so the app can react.
    if (status === 401) {
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      } catch (e) {}
      // Notify the app that session expired so AuthContext can react
      try { window.dispatchEvent(new Event('session:expired')); } catch (e) {}
      // Redirect to login so the user can re-authenticate
      try { window.location.assign('/login'); } catch (e) {}
      return Promise.reject(error);
    }

    // If forbidden (403) do NOT clear client auth — this is an authorization issue (user lacks
    // privilege) rather than an authentication/session expiry. Show a friendly message instead
    // and let the app continue (don't log the user out).
    if (status === 403) {
      try { window.alert('Access denied: you do not have permission to perform this action.'); } catch (e) {}
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;
